import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      ¿Alguna vez has comido una sopa de piedra o una piedra de sopa? ¡Es un plato delicioso! Y ese agradable sabor se
      debe al ingrediente principal y su correcta preparación: se debe poner la piedra de sopa en el fondo de la olla
      con agua fresca y luego llevarla al fuego.
    </p>
    <p className="content justified">
      Este secreto nos fue revelado por un soldado que regresó de campaña en los días de la guerra. Como no tenía qué
      comer, tocó a la puerta en varias casas de un pueblo para preguntar si había algo que le pudieran regalar para
      saciar su hambre. Pero en muchos casos, la respuesta fue negativa.
    </p>
    <p className="content justified">
      Intentó una vez más en una nueva casa: toc toc. Le abrió la puerta una señora amable, quien le dijo que no había
      nada para que él pudiera comer. El soldado le preguntó si tendría una olla que le pudiera prestar, pues él en el
      ejército había aprendido a preparar una exquisita sopa de piedra, utilizando una piedra de sopa.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      “¿Una piedra de sopa?”, se preguntaban la mujer y sus hijos muy sorprendidos. Así que el soldado les explicó que
      esta era una piedra especial, pues era el ingrediente principal para cocinar una rica sopa. Les pidió también
      agua, sal y leña para hacer el fuego.
    </p>
    <p className="content justified">
      Mientras el soldado preparaba la sopa, iba contando sus historias de campaña y tenía capturada la atención de la
      mujer, la hija menor, la hija mayor y el primogénito. Sin que nadie se diera cuenta, la sopa fue creciendo y
      volviéndose cada vez más sabrosa.
    </p>
    <p className="content justified">
      Después de mucha charla y cocción de la piedra de sopa, toda la familia degustó el mejor plato de su vida. Si
      quieres saber en detalle cómo hacer una sopa de piedra, escucha la historia completa.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">De Bélgica a la radio en Colombia</h3>
      <p className="content justified">
        Esta historia de la sopa de piedra es una leyenda de la tradición de Bélgica, ha sido escrita por varios autores
        y tiene versiones diferentes. En este caso, el escritor colombiano Oswaldo Díaz Díaz tomó esta historia e hizo
        un libreto original para la Radiodifusora Nacional de Colombia.
      </p>
      <p className="content justified">
        Este radioteatro empieza con la voz de una narradora que enmarca la historia, pero el resto del relato lo
        conocemos a través de los diálogos del soldado y de los integrantes de la familia con quienes prepara la sopa.
        Nuestra atención está en dos lugares a la vez: en las historias del soldado y en la receta del plato. El manejo
        de Díaz Díaz de estos dos registros es maravilloso, se crea una tensión narrativa e invita a que el oyente esté
        pendiente de cada detalle.
      </p>
      <p className="content justified">
        El uso de la música en este radioteatro nos deja sentir el paso del tiempo a lo largo de la cocción del plato. Y
        al mismo tiempo, los recursos auditivos nos ubican en el espacio en que tiene lugar este episodio.
      </p>
    </div>
    <div className="sectionReview">
      <h3 className="review-title subtitle">La sopa de piedra: para niños y adultos</h3>
      <p className="content justified">
        Esta narración fue emitida el 17 de abril de 1956, en <i>Leyendas</i>, una serie de programas emitidos en un
        horario habitual para adultos, bajo la dirección de Gonzalo Vera Quintana, interpretada por el grupo escénico de
        la emisora. Sin embargo, esta historia de carácter universal tiene también a los niños por destinatarios. La
        radio en estos años fue un medio que congregó a toda la familia en un mismo tiempo y espacio.
      </p>
      <p className="content justified">
        Oswaldo Díaz Díaz le escribió a los niños, los adultos y al niño interior de cada persona mayor.
      </p>
    </div>
  </div>
);
